'use strict';

var Swiper = window.Swiper;

module.exports = function () {
    new Swiper('.blog-carousel', {
        loop: true,
        slidesPerView: 1,
        pagination: {
            el: '.widget-blog-carousel .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
            },
        },
    });
};
